import { Currency } from "@redotech/money/iso4217/currencies";
import { CheckoutSegmentCategory } from "@redotech/redo-conversion-core-common/conversion/checkout-segments/checkout-segment-category";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getSegmentedCheckoutMetrics = {
  name: "getSegmentedCheckoutMetrics" as const,
  input: z.null(),
  output: z.object({
    segments: z.array(
      z.object({
        segmentKey: z.string(),
        name: z.string(),
        category: createEnum(CheckoutSegmentCategory),
        totalCheckoutVisits: z.number(),
        totalCheckoutCompletions: z.number(),
        aov: z.number(),
        conversionRate: z.number(),
        revenuePerCheckoutVisit: z.object({
          amount: z.number(),
          currency: createEnum(Currency),
        }),
      }),
    ),
  }),
};
export type GetSegmentedCheckoutMetricsOutput = z.infer<
  typeof getSegmentedCheckoutMetrics.output
>;
